import styled from 'styled-components';
import { SubjectCardFormElementFontStyle } from '../../../../styles/sharedUIElemStyles';

export const InstruktorStyle = styled('ul')`
	padding-left: 0;
	list-style: none;
	li {
		${SubjectCardFormElementFontStyle};
	}
`;
